import { render, staticRenderFns } from "./WindowSizeAndGlazing.vue?vue&type=template&id=40f31036&scoped=true"
import script from "./WindowSizeAndGlazing.vue?vue&type=script&lang=ts"
export * from "./WindowSizeAndGlazing.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f31036",
  null
  
)

export default component.exports